/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/snowflake-wif-principal/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSnowflakeWifPrincipalAppGroupId } from "./constants";
import type { GetIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupIdResult } from "./types";
import { isGetIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupIdResult } from "./validators";

export const getIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupId = reactQueryFetcherAdapter(
  integrationsDirectCdiSnowflakeWifPrincipalAppGroupId,
  (
    signal: AbortSignal,
    appGroupId: string
  ): Promise<GetIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupIdResult> => {
    return fetch(`/integrations/direct/cdi/snowflake-wif-principal/${appGroupId}`, "GET", {}, { signal });
  },
  isGetIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupIdResult
);
